import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
 import { Container, Row, Col } from "reactstrap";
import "../styles/about.css"
import AboutUs from "../components/AboutUs";
import Counter from "../components/Counter";
import Testimonial from "../components/Testimonial";
import OurMembers from "../components/OurMembers";

const About = () => {
  return (
    <>
    <Meta
      title="About Matel Trading Motors"
      description="Learn about Matel Trading Motors, your trusted partner for vehicle importation."
      keywords="about matel trading motors, car import kenya"
      canonical="https://mateltradingmotors.com/about-us"
    />
      <BreadCrumb title="About Us" />
      <div className="about-wrapper">
      

              <AboutUs/>
      
      <Counter/>
      
       
       {/*
         <Testimonial/>
       <div className="members__wrapper">
       <OurMembers/> 
         </div>
         */} 
     
      </div>
    </>
  );
};

export default About;